import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Briefcase, ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "../../components/ui/button";
import PortfolioForm from "../../components/portfolio/PortfolioForm";
import usePortfolio from "../../hooks/usePortfolio";

const PortfolioAddEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getPortfolioById, addPortfolio, updatePortfolio } = usePortfolio();

  const [loading, setLoading] = useState(id ? true : false);
  const [initialData, setInitialData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (id) {
      const loadProject = async () => {
        setLoading(true);
        const data = await getPortfolioById(id);
        if (data) {
          setInitialData(data);
        } else {
          navigate("/portfolio");
        }
        setLoading(false);
      };
      loadProject();
    }
  }, [id, getPortfolioById, navigate]);

  const onSubmit = async (formData) => {
    setIsSubmitting(true);
    let success;
    if (id) {
      success = await updatePortfolio(id, formData);
    } else {
      success = await addPortfolio(formData);
    }

    if (success) {
      navigate("/portfolio");
    }
    setIsSubmitting(false);
  };

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh]">
        <Loader2 className="animate-spin text-primary mb-4" size={40} />
        <p className="text-slate-500 font-medium">Loading project details...</p>
      </div>
    );
  }

  return (
    <div className="p-6 mx-auto">
      <div className="flex items-center gap-4 mb-8">
        <Button
          variant="ghost"
          onClick={() => navigate("/portfolio")}
          className="rounded-full h-10 w-10 p-0 hover:bg-slate-100"
        >
          <ArrowLeft size={20} />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight flex items-center gap-3">
            <span className="p-1.5 bg-primary/10 text-primary rounded-xl">
              <Briefcase size={20} />
            </span>
            {id ? 'Edit Project' : 'Add New Project'}
          </h1>
          <p className="text-slate-500 text-sm">{id ? 'Update your project specifications.' : 'Tell the story of your project.'}</p>
        </div>
      </div>

      <div className="bg-white rounded-3xl border border-slate-200 p-8 shadow-sm">
        <PortfolioForm
          initialData={initialData}
          onSubmit={onSubmit}
          onCancel={() => navigate("/portfolio")}
          isSubmitting={isSubmitting}
        />
      </div>
    </div>
  );
};

export default PortfolioAddEdit;
